import {
  type BoxProps,
  notEmpty,
  useAggregationsContext,
  useMarketAccountsContext,
  useMarketsContext,
} from '@talos/kyoko';
import type { ReactNode } from 'react';
import { InnerSelectedMarketsDisplay } from './InnerSelectedMarketsDisplay';

type SelectedMarketsDisplayProps = {
  aggregation: string | undefined;
  markets: string[] | undefined;
  marketAccounts: string[] | undefined;
  maxVisibleItems?: number;
  overflowTrigger?: 'button' | 'badge';
  placeholder?: ReactNode;
  tooltip?: ReactNode;
} & BoxProps;

export function SelectedMarketsDisplay({
  aggregation,
  markets,
  marketAccounts,
  maxVisibleItems,
  overflowTrigger,
  ...props
}: SelectedMarketsDisplayProps) {
  const { aggregationsByName } = useAggregationsContext();
  const { marketsByName } = useMarketsContext();
  const { marketAccountsByName } = useMarketAccountsContext();

  const aggregationPreset = aggregation ? aggregationsByName.get(aggregation) : undefined;
  const marketList = markets?.map(market => marketsByName.get(market)).filter(notEmpty);
  const marketAccountList = marketAccounts
    ?.map(marketAccount => marketAccountsByName.get(marketAccount))
    .filter(notEmpty);

  return (
    <InnerSelectedMarketsDisplay
      aggregation={aggregationPreset}
      markets={marketList}
      marketAccounts={marketAccountList}
      maxVisibleItems={maxVisibleItems}
      overflowTrigger={overflowTrigger}
      {...props}
    />
  );
}
